import { render, staticRenderFns } from "./componentInfo.vue?vue&type=template&id=2dc76ae6&scoped=true"
import script from "./componentInfo.vue?vue&type=script&lang=js"
export * from "./componentInfo.vue?vue&type=script&lang=js"
import style0 from "./componentInfo.vue?vue&type=style&index=0&id=2dc76ae6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc76ae6",
  null
  
)

export default component.exports